export const ACCESS_LEVELS = {
  ADMIN: 'ADMIN',
  ALL: 'ALL',
  PM: 'PM',
};

export const ALLOWED_PERSON_IDS = [];
